(ns global.endor.checkout.ui.components.select
  (:require [uix.core :as uix :refer [$ defui]]
            ["react-select" :default react-select]
            [cljs-bean.core :as bean]))

(defui select-styles []
  ($ :style
     {}
     (str ".endor-select {background-color: transparent;}"
          ".endor-select__control {background-color: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-radius: 4px;}"
          ".endor-select__control:hover {background-color: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.2);}"
          ".endor-select__control--is-focused {background-color: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.3); box-shadow: 0 0 0 1px rgba(255,255,255,0.1);}"
          ".endor-select__single-value {color: rgba(255,255,255,0.9); font-family: Space Grotesk;}"
          ".endor-select__placeholder {color: rgba(255,255,255,0.5); font-family: Space Grotesk;}"
          ".endor-select__input {color: rgba(255,255,255,0.9);}"
          ".endor-select__menu {background-color: rgba(20,20,20,0.95); border: 1px solid rgba(255,255,255,0.1); border-radius: 4px; box-shadow: 0 4px 12px rgba(0,0,0,0.3);}"
          ".endor-select__option {background-color: transparent; color: rgba(255,255,255,0.8); font-family: Space Grotesk;}"
          ".endor-select__option:hover {background-color: rgba(255,255,255,0.08); color: rgba(255,255,255,0.95);}"
          ".endor-select__option--is-selected {background-color: rgba(255,255,255,0.15); color: rgba(255,255,255,1);}"
          ".endor-select__option--is-focused {background-color: rgba(255,255,255,0.08);}"
          ".endor-select__indicator-separator {background-color: rgba(255,255,255,0.1);}"
          ".endor-select__dropdown-indicator {color: rgba(255,255,255,0.6);}"
          ".endor-select__dropdown-indicator:hover {color: rgba(255,255,255,0.8);}")))

(defui select [{:keys [placeholder on-change options default-value]}]
  (let [[^js value set-value] (uix.core/use-state (bean/->js default-value))]
    ($ :<>
       ($ select-styles)
       ($ react-select
          {:default-value value
           :on-change (fn [x]
                        (set-value x)
                        (when on-change
                          (on-change (.-value x))))
           :placeholder (or placeholder "Select something")
           :className "endor-select"
           :classNamePrefix "endor-select"
           :is-searchable false
           :options (bean/->js options)}))))
